import { render } from "./UHeader.vue?vue&type=template&id=668e503d&scoped=true"
import script from "./UHeader.vue?vue&type=script&lang=js"
export * from "./UHeader.vue?vue&type=script&lang=js"

import "./UHeader.vue?vue&type=style&index=0&id=668e503d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668e503d"]])

export default __exports__